/**
 * client/src/lib/secret-input-props.ts — the attributes for a text input that holds a guardian-question secret (Rule 5; ledger #151).
 * `spellCheck={false}` and `autoCorrect="off"` stop the browser's own spell-check and autocorrect from sending the typed text to a
 * cloud service (Chrome's enhanced spell-check, Microsoft Editor); `autoComplete="off"` keeps it out of the browser's form history;
 * `autoCapitalize="off"` stops a mobile browser rewriting it. Browser extensions and mobile keyboards are outside the page's
 * control: this is a mitigation on the attributes the page owns, not a guarantee. Spread it onto the input:
 * `<input {...SECRET_INPUT_PROPS} />`.
 */

export interface SecretInputProps {
  autoComplete: "off";
  autoCorrect: "off";
  autoCapitalize: "off";
  spellCheck: false;
}

export const SECRET_INPUT_PROPS: SecretInputProps = {
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
};
